import  { useEffect, useRef, useState } from 'react';
import useAuthStore from '../store/useAuthStore';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSendLikeStore } from '../store/useSendLikeStore';
import { useMessageStore } from '../store/useMessageStore';
import { useSubscriptionStore } from '../store/useSubscriptionStore';
import { useSingleMatchStore } from '../store/useSingleMatchStore';
import { Link, useNavigate, useParams } from 'react-router-dom';
import location_dark from '../assets/images/location_dark.png';
import { useMatchStore } from '../store/useMatchStore';
import { usePitchesStore } from '../store/usePitchesStore';
import GradientCircularProgress from '../components/GradientCircularProgress';
import { useUserStore } from '../store/useUserStore';
import { getSizedImageUrl } from '../utils/getSizedImageUrl';
import default150 from '../assets/images/default150.png';


const WSurl = import.meta.env.VITE_APP_WS_URL;
const MySwal = withReactContent(Swal);

const MessageBox = () => {
  const navigate = useNavigate();
  const { requestId } = useParams<{ requestId: string }>();
  const { getMessages, userMessages } = useMessageStore();
  const {newRequest } = useUserStore();
  const {deleteRequest } = usePitchesStore();
  const { match, getSingleMatch,updatePriority } = useSingleMatchStore();
  const { blockUser,
    reportUser } = useMatchStore();
  const { sendLike } = useSendLikeStore();
  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user?.id;

  const [messages, setMessages] = useState<any[]>([]);
  const [message, setMessage] = useState('');
  const [socket, setSocket] = useState<{ send: (msg: any) => void } | null>(null);
  const [messageCount, setMessageCount] = useState(0);

  const chatRef = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [yourInterest, setYourInterest] = useState(50);
  const sliderRef = useRef<HTMLInputElement | null>(null);
 const [resolvedImageUrl, setResolvedImageUrl] = useState<string>("");
 const [avatarMap, setAvatarMap] = useState<Record<string, string>>({});


 useEffect(() => {
  (async () => {
    const newAvatarMap: Record<string, string> = {};

    for (const msg of messages) {
      const id = msg.user?.id || msg.from; // fallback to `from` as ID
      const rawUrl = msg.user_photos?.[0]?.picture;
      const fallback = msg.user?.pic || default150;

      const finalUrl = rawUrl
        ? await getSizedImageUrl(rawUrl, "150x150")
        : fallback;

      newAvatarMap[id] = finalUrl || fallback;
    }

    setAvatarMap(newAvatarMap);
  })();
}, [messages]);

   // Function to update slider background based on value
  const updateSliderBackground = () => {
    const slider = sliderRef.current;
      if (!slider) return; 
    const max = parseInt(slider.max);
    const value = parseInt(slider.value);
    const percent = (value / max) * 100;
    slider.style.backgroundSize = `${percent}% 100%`;
  };

    // Update background on value change
  useEffect(() => {
    updateSliderBackground();
  }, [yourInterest]);



useEffect(() => {
  (async () => {
    let rawUrl = "";
    let fallback = "";

    if (match?.user?.id === userId) {
      rawUrl = match?.user_photos_to?.[0]?.picture;
      fallback = match?.user_to?.pic || "";
    } else {
      rawUrl = match?.user_photos?.[0]?.picture;
      fallback = match?.user?.pic || "";
    }

    const finalUrl = rawUrl ? await getSizedImageUrl(rawUrl, "150x150") : fallback;

    setResolvedImageUrl(finalUrl || fallback);
  })();
}, [match, userId]);
  useEffect(() => {
    const chatBody = chatRef.current;
    if (!chatBody) return;
  
    const handleScroll = async () => {
      if (chatBody.scrollTop === 0 && hasMore) {
        const previousScrollHeight = chatBody.scrollHeight;
        const chatUser = userId == match?.from ? match.user_to : match.user;
        const res = await getMessages(userId, chatUser.id, page + 1);
        if (res.length === 0) setHasMore(false);
  
        setPage((prev) => prev + 1);
  
        // Maintain scroll position after loading more
        setTimeout(() => {
          const newScrollHeight = chatBody.scrollHeight;
          chatBody.scrollTop = newScrollHeight - previousScrollHeight;
        }, 50);
      }
    };
  
    chatBody.addEventListener('scroll', handleScroll);
    return () => chatBody.removeEventListener('scroll', handleScroll);
  }, [page, hasMore, match]);

  useEffect(() => {
    getSingleMatch(parseInt(requestId ?? '0'));
        
    }, []);
    useEffect(() => {
  if (requestId) {
    getSingleMatch(parseInt(requestId));
  }
}, [requestId]);

    useEffect(() => {
      const chatBody = document.querySelector('.mymatches_chat_body');
      if (chatBody) chatBody.scrollTop = chatBody.scrollHeight;
    }, [messages]);

  useEffect(() => {
    
    setMessages(userMessages);
    setMessageCount(userMessages?.length);
  }, [userMessages]);

    useEffect(() => {
    const interval = setInterval(async () => {
      if(newRequest.notificationsCount>0){
        
      }
     
   }, 3000); // 60000 ms = 1 minute
  return () => clearInterval(interval); // Cleanup on unmount
  }, [newRequest?.newRequestCount, page]);

  useEffect(() => {
    if (userId && match) {

      setYourInterest(parseInt(match.from == userId ? match.priority : match.to_priority));
      const chatUser = userId == match.from ? match.user_to : match.user;
      getMessages(userId, chatUser.id,1);
      getSubscription(userId);
    }
  }, [userId, match]);

useEffect(() => {
  if (!userId || !match) return;

  const chatUserId = userId == match.from ? match.to : match.from;
  const connectionKey = `${chatUserId}-${userId}`;
  let client: WebSocket | null = null;
  let heartbeatInterval: NodeJS.Timeout | null = null;
  let reconnectTimeout: NodeJS.Timeout | null = null;

  // 🔑 retry state
  let retryCount = 0;
  const maxRetries = 5; // ⏳ set your retry limit

  // Queue for unsent messages when socket is down
  const pendingMessages: string[] = [];

  const safeSend = (msg: any) => {
    const str = JSON.stringify(msg);

    if (client?.readyState === WebSocket.OPEN) {
      client.send(str);
    } else {
      console.warn("Socket not open, queueing message:", msg);
      pendingMessages.push(str);
      reconnect(); // 🔑 trigger reconnect immediately
    }
  };

  const flushQueue = () => {
    while (client?.readyState === WebSocket.OPEN && pendingMessages.length > 0) {
      const msg = pendingMessages.shift();
      if (msg) client.send(msg);
    }
  };

  const connect = () => {
    if (retryCount >= maxRetries) {
      console.error("❌ Max retries reached. WebSocket not reconnecting.");
      return;
    }

    console.log("Connecting WebSocket...");
    client = new WebSocket(`${WSurl}${chatUserId}${userId}?type=message`);
    setSocket({ send: safeSend }); // expose only safeSend

    // Heartbeat
    heartbeatInterval = setInterval(() => {
      if (client?.readyState === WebSocket.OPEN) {
        client.send(JSON.stringify({ type: "ping" }));
      }
    }, 20000);

    client.onopen = () => {
      console.log("✅ WebSocket connected");
      retryCount = 0; // reset on success
      client?.send(
        JSON.stringify({
          type: "connection_init",
          connectionKey,
          userId,
          chatUserId,
        })
      );
      flushQueue(); // 🔑 send queued messages immediately
    };

    client.onclose = () => {
      console.log("⚠️ WebSocket closed");
      if (heartbeatInterval) clearInterval(heartbeatInterval);
      reconnect(); // immediate reconnect
    };

    client.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("+++++++", data);

      if (["ping", "pong", "heartbeat"].includes(data.type)) return;
      if (data.type === "error") {
        showUpgradePlanAlert();
        return;
      }

      setMessages((prev) => [data, ...prev]);
    };
  };

  const reconnect = () => {
    if (retryCount >= maxRetries) {
      console.error("❌ Stopping reconnect attempts. Limit reached.");
      return;
    }

    retryCount++;
    const delay = Math.min(1000 * retryCount, 10000); // ⏱ exponential backoff, cap at 10s

    if (reconnectTimeout) clearTimeout(reconnectTimeout);
    reconnectTimeout = setTimeout(() => {
      console.log(`🔄 Reconnecting WebSocket... attempt ${retryCount}`);
      connect();
    }, delay);
  };

  // First connection
  connect();

  return () => {
    if (heartbeatInterval) clearInterval(heartbeatInterval);
    if (reconnectTimeout) clearTimeout(reconnectTimeout);
    if (client?.readyState === WebSocket.OPEN) client.close();
  };
}, [userId, match]);


  function formatDate(dateString: any) {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();
    const time = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
    return `${month} ${day}  ${time}`;
  }


  const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>Upgrade your plan in <a href="/mywallet" className="text-primary">MyWallet</a> to send more messages.</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>Close</button>
            <a href="/mywallet" className="btn btn-primary">Upgrade Now</a>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

const handleSendMessage = async () => {
  try {
    // Validate payment status and message count
    if (paymentDetails?.status === 0 && messageCount >= 50) {
      showUpgradePlanAlert();
      return;
    }

    // Validate message content and connection
    if (!message.trim()) {
      return;
    }

    if (!socket) {
      console.error('No socket available');
      return;
    }

    const chatUserId = userId == match?.from ? match?.to : match?.from;
    
    // Validate we have a recipient
    if (!chatUserId) {
      console.error('No recipient user ID');
      return;
    }

    // Prepare message data
    const messageData =  { 
       from: userId,
       to: chatUserId,
        message, 
        message_type: "text",
        createdAt: new Date().toISOString(),
        user: userId == match.from ? match.user : match.user_to,
        user_to:userId == match.from ? match.user_to : match.user,
        user_photos:userId == match.from ? match.user_photos : match.user_photos_to,
        user_photos_to:userId == match.from ? match.user_photos_to : match.user_photos,
     };

    // Send message
    socket.send(messageData); // safeSend will JSON.stringify + queue if needed
    setMessage('');

 

    // Handle first message logic
    if (messageCount === 0 && (!requestId || requestId === '')) {
      try {
        await sendLike(chatUserId, 50, '', requestId ?? '');
      } catch (error) {
        console.error('Error sending like:', error);
      }
    }

    // Update message count for free users
    if (paymentDetails?.status === 0) {
      setMessageCount(prev => prev + 1);
    }

  } catch (error) {
    console.error('Error sending message:', error);
  }
};



  const confirmBlockUser = (userId:any, requestId:any, blockUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Block User?</h3>
          <p>Do you really want to block this user?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={() => { 
              blockUser(userId,requestId); 
              navigate('/matched');
              MySwal.close();
            }}>
              Yes, Block
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };


  
  const confirmReportUser = (userId:any, reportUser:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Report User</h3>
          <p>Please enter the reason for reporting this user:</p>
          <textarea
            id="reportReason"
            className="form-control mb-3"
            placeholder="Enter your reason..."
            style={{ height: '100px', resize: 'none' }}
          ></textarea>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={() => {
                const reasonInput = document.getElementById('reportReason') as HTMLTextAreaElement;
                if (!reasonInput || !reasonInput.value.trim()) {
                  MySwal.showValidationMessage('Reason is required.');
                  return;
                }
                reportUser(userId, reasonInput.value.trim());
                MySwal.close();
                MySwal.fire('Reported!', 'The user has been reported successfully.', 'success');
              }}
            >
              Submit Report
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };  

  const confirmDeleteRequest = (requestId:any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Unmatch User?</h3>
          <p>Do you really want to Unmatch this user?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={() => { 
              deleteRequest(requestId); 
              MySwal.close();
            }}>
              Yes, Unmatch
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'bg-light p-4 rounded',
        closeButton: 'btn-close position-absolute top-0 end-0 m-3',
      },
    });
  };

  return (
  <section className="pt-4 pb-60 bg-light">
    <div className="container">
        <div className="dp_profile_top_bredcrumb mb-4">
            <Link to="/matched" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </Link>
        </div>
        <div className="row">
            <div className="col-lg-8">
                <div className="card mymatches_chat_card mb-4 ">
                    <div className="mymatches_chat_header">
                    {match?.user.id == userId ?
                        <div className="mymatches_dp_item_profile_info">
                            <div className="mymatches_dp_item_img_box">
                             
                                <div className="mymatches_dp_item_img_box">
                                  <img src={resolvedImageUrl} alt="" className="img-fluid" />
                                </div>
                          
                            
                            </div>
                            <div>
                                <h2 className='f-name'>{match?.user_to?.first_name}</h2>
                                <p className="mb-0 location-text"><img src={location_dark} className="me-2" />{match?.user_to?.city} {match?.user_to?.state},
                                  &nbsp; {match?.user_to?.distance.toFixed(0)} miles away</p>
                                  <button className="btn btn-outline-primary py-2 d-smm-block d-none mt-1 pro-chat" onClick={()=> navigate(`/profile/${match.user.id == userId ? match.user_to.id : match.user.id}`)}>View profile</button>
                            </div>
                        </div>
                        :
                        <div className="mymatches_dp_item_profile_info">
                            <div className="mymatches_dp_item_img_box">
                             
                                <img src={resolvedImageUrl} alt="" className="img-fluid" />
                            
                            </div>
                            <div>
                                <h2 className='f-name'>{match?.user?.first_name}</h2>
                                <p className="mb-0 location-text"><img src={location_dark} className="me-2" />{match?.user?.city} {match?.user?.state},
                                  &nbsp; {match?.user?.distance.toFixed(0)} miles away</p>
                                  <button className="btn btn-outline-primary py-2 d-smm-block d-none mt-1 pro-chat" onClick={()=> navigate(`/profile/${match.user.id == userId ? match.user_to.id : match.user.id}`)}>View profile</button>
                            </div>
                        </div>
                        
                        }

                        <div className="d-flex align-items-center gap-3">
                            <button className="btn btn-outline-primary py-2 d-md-block d-none" onClick={()=> navigate(`/profile/${match.user.id == userId ? match.user_to.id : match.user.id}`)}>View profile</button>
                            <div className="dp_info_drpdwn_wrpr">
                                <button className="btn btn-sm dropdown-toggle dp_info_drpdwn" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="#" onClick={()=>confirmDeleteRequest(match.id)}>Unmatch</a></li>
                                    <li><a className="dropdown-item" href="#" onClick={() => confirmBlockUser(match.user.id == userId ? match.user_to.id : match.user.id,match.id, blockUser)}>Block User</a></li>
                                    <li><a className="dropdown-item" href="#" onClick={() => confirmReportUser(match.user.id == userId ? match.user_to.id : match.user.id, reportUser)}>Report</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="mymatches_chat_body" ref={chatRef}>
                    
                    {messages.length === 0 ? (
                              <div className="text-center">
                                <h3>
                                  <i className="fa-regular fa-comment-dots text-primary"></i> Ready to chat?
                                </h3>
                                <p>Start the conversation for free, then wait for their response. You’ve got this!</p>
                              </div>
                            ) : (
                              <div className="dp_message_box_lists_main" >
                                {[...messages].reverse().map((msg) => {
                                   const avatar = avatarMap[msg.user?.id || msg.from] || default150;
                                   return (
                                    <div className={`mymatches_chat_message ${msg.from == userId ? 'mymatches_sender' : 'mymatches_receiver'}`}>
                                      <div className="mymatches_message_top_row">
                                        <span className="mymatches_message_time">{formatDate(msg.createdAt)}</span>
                                      </div>
                                      <div className="mymatches_message_bottom_row">
                                      {msg.from != userId && (
                                          <div className="mymatches_user_avatar">
                                             <img src={avatar} alt="User Avatar" />
                                          </div>
                                        )}
                                        
                                        <div className="mymatches_message_content">
                                          <div className="mymatches_message_text">{msg.message}</div>

                                        </div>
                                       {msg.from == userId && (
                                          <div className="mymatches_user_avatar">
                                             <img src={avatar} alt="User Avatar" />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}

                    </div>
                    <div className="mymatches_chat_footer chatbox_bottom">
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Start the conversation.." value={message} onChange={(e) => setMessage(e.target.value)}  onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault(); // Prevents default form submit behavior
                              handleSendMessage();
                            }
                          }} />
                            <button className="btn"  onClick={()=>handleSendMessage()}>
                                <i className="fa-solid fa-paper-plane"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-lg-4">
              <div className="card dp_matches_chat_right border text-center">
                 <h2 className=' mb-3'>Love Diamond™ </h2>
                {/* Their Interest */}
                <div className="dp_matches_chat_right_item d-flex align-items-center justify-content-between">
                  <div>
                    <h5>
                      Their Interest
                      </h5>
                    <h3>{match?.from == userId ? match?.to_priority : match?.priority}<span>%</span></h3>
                  </div>
                  <GradientCircularProgress value={match?.from == userId ? match?.to_priority : match?.priority} id="their-interest" type='their_interest' />
                 
                </div>

                {/* Your Interest */}
                <div className="dp_matches_chat_right_item dp_matches_yourintrest_item">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5>Your Interest</h5>
                      <h3>{yourInterest}<span>%</span></h3>
                    </div>


                    <GradientCircularProgress value={yourInterest} id="your-interest" type='' />
                    
                    
                  </div>
                </div>

                {/* Slider */}
                
                <div className="dp_matches_chat_range">
                  <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="100"
                    step="1"
                    id="interestRangeSlider"
                   ref={sliderRef}
                  value={yourInterest}
                    onChange={(e) => setYourInterest(Number(e.target.value))}
                    onMouseUp={() => updatePriority(match.id, yourInterest, match?.from == userId ? 'priority' : 'to_priority')}
                    onTouchEnd={() => updatePriority(match.id, yourInterest, match?.from == userId ? 'priority' : 'to_priority')}
                  />
                  <div className="range-labels">
                    <span>0%</span>
                    <span>25%</span>
                    <span>50%</span>
                    <span>75%</span>
                    <span>100%</span>
                  </div>
                </div>
                <div className='d-flex  justify-content-between'>
                  <div className="text-primary text-left mt-2  d-flex justify-content-start align-items-center gap-2" style={{ fontSize: '0.8rem' }}>
                  
                  *Move the slider to set your interest level.  
                </div>
                <div className='pat-pending d-flex justify-content-start align-items-center mt-2'>Patent Pending</div>
                </div>
                 
              </div>

            </div>

        </div>
    </div>
  </section>



  );
};

export default MessageBox;
